import { useCallback, useEffect, useState } from "react";
import { EMPTY_STRING } from "../common/constants/common.constants";
import { DashboardFilter } from "../common/enums/dashboard.enums";

const useModifier = (
  initialItems: any[],
  filterType: DashboardFilter,
  secondItemsArray?: any[]
) => {
  const [filteredItems, setFilteredItems] = useState(
    initialItems ? [...initialItems] : []
  );
  const [filters, setFilters] = useState<{
    clubName: string;
    filterItems: any[];
  }>({ clubName: EMPTY_STRING, filterItems: [] });

  useEffect(() => {
    if (initialItems.length > 0) applyFilters();
  }, [filters, initialItems]);

  const addFilterItem = (filterItem: any) => {
    const existingItem = filters.filterItems.find(
      (item) => item === filterItem
    );
    let appliedFilters = [...filters.filterItems];
    if (!existingItem) {
      appliedFilters.push(filterItem);
    } else {
      appliedFilters = filters.filterItems.filter(
        (item) => item !== filterItem
      );
    }
    const newFilters = {
      clubName: filters.clubName,
      filterItems: appliedFilters,
    };
    setFilters(newFilters);
  };

  const addFilterByName = (name: string) => {
    const appliedFilters = { ...filters };
    appliedFilters.clubName = name;
    setFilters(appliedFilters);
  };

  const applyFilters = () => {
    applyFilter(filterType);
  };
  const applyFilter = useCallback(
    (key: string) => {
      let items = [...initialItems];
      if (filters.filterItems.length > 0) {
        items = (secondItemsArray ? secondItemsArray : initialItems).filter(
          (item) => {
            return item !== null && filters.filterItems.includes(item[key]);
          }
        );
      } else {
        items = initialItems;
      }
      if (filters.clubName !== EMPTY_STRING) {
        items = items.filter((item) =>
          item.club.clubName
            .toLowerCase()
            .includes(filters.clubName.toLowerCase())
        );
      }
      if (secondItemsArray && filters.filterItems.length > 0) {
        const newItems = initialItems.filter((item) =>
          items.find(
            (secondItem) =>
              secondItem.club.clubAddress === item.club.clubAddress
          )
        );
        setFilteredItems(newItems);
      } else {
        setFilteredItems(items);
      }
    },
    [initialItems, filters]
  );

  return {
    filteredItems,
    addFilterItem,
    addFilterByName,
  };
};

export default useModifier;
